import UpgradeHandle from '@/pages/handle/upgradeHandle'

export default [
  {
    path: '/upgradeHandle',
    name: 'UpgradeHandle',
    component: UpgradeHandle,
    meta: { name: '升级处理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/upgradeHandle.js